import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  faqTitle: {
    id: 'portal.views.faq.label.title',
    defaultMessage: 'Frequently Asked Questions',
    description: 'FAQ page title',
  },
  qRegisterAccount: {
    id: 'portal.views.faq.question.registerAccount',
    defaultMessage: 'HOW DO I REGISTER A NEW ACCOUNT?',
    description: 'FAQ question: register account',
  },
  aRegisterAccountStep1: {
    id: 'portal.views.faq.answer.registerAccountStep1',
    defaultMessage: 'Go to <link>www.leadingwithcharacter.com</link> and click Login at the upper right-hand corner of the page.',
    description: 'FAQ answer step 1: register account',
  },
  aRegisterAccountStep1Alt: {
    id: 'portal.views.faq.answer.registerAccountStep1Alt',
    defaultMessage: 'Go to www.leadingwithcharacter.com and click Login.',
    description: 'Plain alt text for register account step 1',
  },
  aRegisterAccountStep2: {
    id: 'portal.views.faq.answer.registerAccountStep2',
    defaultMessage: 'Click Don’t have an account? Sign Up and enter your details as requested.',
    description: 'FAQ answer step 2: register account',
  },
  aRegisterAccountStep2Alt1: {
    id: 'portal.views.faq.answer.registerAccountStep2Alt1',
    defaultMessage: 'Sign up screen with fields to create an account.',
    description: 'Plain alt text for register account step 2 (first image)',
  },
  aRegisterAccountStep2Alt2: {
    id: 'portal.views.faq.answer.registerAccountStep2Alt2',
    defaultMessage: 'Additional sign up details screen.',
    description: 'Plain alt text for register account step 2 (second image)',
  },
  qChangePassword: {
    id: 'portal.views.faq.question.changePassword',
    defaultMessage: 'HOW DO I CHANGE MY PASSWORD?',
    description: 'FAQ question: change password',
  },
  aChangePasswordStep1: {
    id: 'portal.views.faq.answer.changePasswordStep1',
    defaultMessage: 'Click <bold>Login</bold> and go to the login page.',
    description: 'FAQ answer step 1: change password',
  },
  aChangePasswordStep1Alt: {
    id: 'portal.views.faq.answer.changePasswordStep1Alt',
    defaultMessage: 'Click Login and go to the login page.',
    description: 'Plain alt text for change password step 1',
  },
  aChangePasswordStep2: {
    id: 'portal.views.faq.answer.changePasswordStep2',
    defaultMessage: 'Enter your email address or username and click <bold>continue</bold>.',
    description: 'FAQ answer step 2: change password',
  },
  aChangePasswordStep3: {
    id: 'portal.views.faq.answer.changePasswordStep3',
    defaultMessage: 'Click <bold>forgot password?</bold> and follow the instructions to reset a password.',
    description: 'FAQ answer step 3: change password',
  },
  aChangePasswordStep3Alt: {
    id: 'portal.views.faq.answer.changePasswordStep3Alt',
    defaultMessage: 'Use the “forgot password” option to reset your password.',
    description: 'Plain alt text for change password step 3',
  },
  qTroubleSignIn: {
    id: 'portal.views.faq.question.troubleSignIn',
    defaultMessage: 'I\'M HAVING TROUBLE SIGNING IN. WHAT SHOULD I DO?',
    description: 'FAQ question: trouble signing in',
  },
  aTroubleSignInStep1: {
    id: 'portal.views.faq.answer.troubleSignInStep1',
    defaultMessage: 'Check your credentials. Ensure you are using the correct email and password. '
      + 'If using autofill, try entering your details manually.',
    description: 'FAQ answer step 1: trouble signing in',
  },
  aTroubleSignInStep2: {
    id: 'portal.views.faq.answer.troubleSignInStep2',
    defaultMessage: 'Clear your browser history, cache, and cookies.',
    description: 'FAQ answer step 2: trouble signing in',
  },
  aTroubleSignInStep3: {
    id: 'portal.views.faq.answer.troubleSignInStep3',
    defaultMessage: 'Try a different browser and device.',
    description: 'FAQ answer step 3: trouble signing in',
  },
  aTroubleSignInStep4: {
    id: 'portal.views.faq.answer.troubleSignInStep4',
    defaultMessage: 'Try resetting your password – use the <bold>forgot password</bold> option to reset it.',
    description: 'FAQ answer step 4: trouble signing in',
  },
  aTroubleSignInStep4Alt: {
    id: 'portal.views.faq.answer.troubleSignInStep4Alt',
    defaultMessage: 'Use the forgot password option to reset your password.',
    description: 'Plain alt text for trouble signing in step 4',
  },
  qVideosStopped: {
    id: 'portal.views.faq.question.videosStopped',
    defaultMessage: 'WHY HAVE MY VIDEOS STOPPED PLAYING?',
    description: 'FAQ question: videos stopped',
  },
  aVideosStoppedStep1: {
    id: 'portal.views.faq.answer.videosStoppedStep1',
    defaultMessage: 'Refresh the page or try a different browser.',
    description: 'FAQ answer step 1: videos stopped',
  },
  aVideosStoppedStep2: {
    id: 'portal.views.faq.answer.videosStoppedStep2',
    defaultMessage: 'Check your internet connection.',
    description: 'FAQ answer step 2: videos stopped',
  },
  aVideosStoppedStep3: {
    id: 'portal.views.faq.answer.videosStoppedStep3',
    defaultMessage: 'Clear your browser history, cache, and cookies.',
    description: 'FAQ answer step 3: videos stopped',
  },
  aVideosStoppedStep4: {
    id: 'portal.views.faq.answer.videosStoppedStep4',
    defaultMessage: 'Disable any browser extensions that might block videos.',
    description: 'FAQ answer step 4: videos stopped',
  },
  qCantProgress: {
    id: 'portal.views.faq.question.cantProgress',
    defaultMessage: 'I CAN\'T PROGRESS TO THE NEXT MODULE, EVEN THOUGH I\'VE COMPLETED EVERYTHING.',
    description: 'FAQ question: cannot progress',
  },
  aCantProgressStep1: {
    id: 'portal.views.faq.answer.cantProgressStep1',
    defaultMessage: 'Check that all unit tabs within the module display green checkmarks. '
      + 'When you complete a unit, the tab associated with that unit turns green and a check mark appears. '
      + 'In the screen shot below, you will see that the first two units are completed as shown '
      + 'by the green tabs. If a tab remains white (units 3 through 9 in the screenshot below), '
      + 'that means that not all activities in those units are registered as complete. Go back to '
      + 'the corresponding unit and read all text, watch all videos, and click on all hotspots.',
    description: 'FAQ answer step 1: cannot progress',
  },
  aCantProgressStep1Alt: {
    id: 'portal.views.faq.answer.cantProgressStep1Alt',
    defaultMessage: 'Module page showing green checkmarks for completed units.',
    description: 'Plain alt text for cannot progress step 1 screenshot',
  },
  aCantProgressStep2: {
    id: 'portal.views.faq.answer.cantProgressStep2',
    defaultMessage: 'In order for a unit to be marked complete, you must watch the videos in entirety, '
      + 'read all text, answer all quiz questions, and click and read all hotspots as shown in the screenshot below.',
    description: 'FAQ answer step 2: cannot progress',
  },
  aCantProgressStep2Alt1: {
    id: 'portal.views.faq.answer.cantProgressStep2Alt1',
    defaultMessage: 'Course content screen with unit requirements.',
    description: 'Plain alt text for cannot progress step 2 (first image)',
  },
  aCantProgressStep2Alt2: {
    id: 'portal.views.faq.answer.cantProgressStep2Alt2',
    defaultMessage: 'Course banner showing completion status.',
    description: 'Plain alt text for cannot progress step 2 (second image)',
  },
  qContentNotLoad: {
    id: 'portal.views.faq.question.contentNotLoad',
    defaultMessage: 'WHY DOES THE CONTENT NOT LOAD, AND WHY DO THE MODULES APPEAR BLANK?',
    description: 'FAQ question: content not loading',
  },
  aContentNotLoadStep1: {
    id: 'portal.views.faq.answer.contentNotLoadStep1',
    defaultMessage: 'Refresh the page or try accessing it in a different browser.',
    description: 'FAQ answer step 1: content not loading',
  },
  aContentNotLoadStep2: {
    id: 'portal.views.faq.answer.contentNotLoadStep2',
    defaultMessage: 'Check your internet connection.',
    description: 'FAQ answer step 2: content not loading',
  },
  aContentNotLoadStep3: {
    id: 'portal.views.faq.answer.contentNotLoadStep3',
    defaultMessage: 'Clear your browser history, cache, and cookies.',
    description: 'FAQ answer step 3: content not loading',
  },
  aContentNotLoadStep4: {
    id: 'portal.views.faq.answer.contentNotLoadStep4',
    defaultMessage: 'Ensure your browser and operating system are up to date.',
    description: 'FAQ answer step 4: content not loading',
  },
  aContentNotLoadStep5: {
    id: 'portal.views.faq.answer.contentNotLoadStep5',
    defaultMessage: 'Disable any extensions that may block content.',
    description: 'FAQ answer step 5: content not loading',
  },
  qFindCertificate: {
    id: 'portal.views.faq.question.findCertificate',
    defaultMessage: 'WHERE CAN I FIND MY COMPLETION CERTIFICATE?',
    description: 'FAQ question: find certificate',
  },
  aFindCertificateStep1: {
    id: 'portal.views.faq.answer.findCertificateStep1',
    defaultMessage: 'Hover over the profile icon in the upper right-hand corner and click on <bold>Dashboard</bold>.',
    description: 'FAQ answer step 1: find certificate',
  },
  aFindCertificateStep1Alt: {
    id: 'portal.views.faq.answer.findCertificateStep1Alt',
    defaultMessage: 'Open the Dashboard from the profile icon.',
    description: 'Plain alt text for find certificate step 1',
  },
  aFindCertificateStep2: {
    id: 'portal.views.faq.answer.findCertificateStep2',
    defaultMessage: 'Click on the icon of the completed module for which you would like a certificate. '
      + 'If you would like to download the full course completion certificate, click '
      + 'on the <bold>Leading Forward</bold> icon. Download the certificate that appears.',
    description: 'FAQ answer step 2: find certificate',
  },
  aFindCertificateStep2Alt: {
    id: 'portal.views.faq.answer.findCertificateStep2Alt',
    defaultMessage: 'Profile page with certificates and module icons.',
    description: 'Plain alt text for find certificate step 2',
  },
  aFindCertificateStep3: {
    id: 'portal.views.faq.answer.findCertificateStep3',
    defaultMessage:
      'If you would like to change the name appearing on your certificate, complete fields for your full name by clicking on the pencil icon next to "My Personal Information".',
    description: 'FAQ answer step 3: find certificate',
  },
  qNameIncorrect: {
    id: 'portal.views.faq.question.nameIncorrect',
    defaultMessage: 'THE NAME ON MY CERTIFICATE IS INCORRECT. HOW CAN I CHANGE IT?',
    description: 'FAQ question: name incorrect',
  },
  aNameIncorrect: {
    id: 'portal.views.faq.answer.nameIncorrect',
    defaultMessage: 'If you would like to change the name appearing on your certificate, '
      + 'complete fields for your full name by clicking on the pencil icon next to “My Personal Information”.',
    description: 'FAQ answer: name incorrect',
  },
  aNameIncorrectAlt: {
    id: 'portal.views.faq.answer.nameIncorrectAlt',
    defaultMessage: 'Edit profile screen showing personal information fields.',
    description: 'Plain alt text for name incorrect screenshot',
  },
  qStayUpToDate: {
    id: 'portal.views.faq.question.stayUpToDate',
    defaultMessage: 'HOW CAN I STAY UP TO DATE ABOUT ADDITIONAL COURSES OR RESOURCES ON LEADING WITH CHARACTER?',
    description: 'FAQ question: stay up to date',
  },
  aStayUpToDate: {
    id: 'portal.views.faq.answer.stayUpToDate',
    defaultMessage: 'To stay up to date on future Leading with Character webinars, courses, '
      + 'and events, follow the following social media accounts:',
    description: 'FAQ answer: stay up to date',
  },
  qStillIssues: {
    id: 'portal.views.faq.question.stillIssues',
    defaultMessage: 'STILL EXPERIENCING ISSUES?',
    description: 'FAQ question: still issues',
  },
  aStillIssues: {
    id: 'portal.views.faq.answer.stillIssues',
    defaultMessage: 'If the problem persists after trying all the steps above, please contact support at '
      + '<link>support@leadingwithcharacter.com</link>.',
    description: 'FAQ answer: still issues',
  },
  youtubeIframeTitle: {
    id: 'portal.views.faq.iframe.youtubeTitle',
    defaultMessage: 'YouTube video player',
    description: 'Title for the embedded YouTube video iframe',
  },
});

export default messages;
